import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { CancelCrossIcon, Header2, IconButton } from "@activecollab/components";
import classnames from "classnames";
import { useConversationContentContext } from "../../context/index.jsx";

export const CreateTaskHeader = () => {
  const { setMode } = useConversationContentContext();
  const { t } = useTranslation();

  const handleReturnDefaultMode = useCallback(() => {
    setMode("");
  }, [setMode]);

  return (
    <>
      <IconButton
        variant="text gray"
        onClick={handleReturnDefaultMode}
        className="tw-mr-1 tw-shrink-0"
      >
        <CancelCrossIcon />
      </IconButton>
      <Header2
        weight="bold"
        color="primary"
        className={classnames("tw-truncate tw-ml-1 tw-min-w-0")}
      >
        {t("Create Task")}
      </Header2>
    </>
  );
};

CreateTaskHeader.displayName = "CreateTaskHeader";
